import React, { useEffect, useState } from "react";
import content from "main/helpers/contentHelper.json";
import cookieBanner from "../../../main/assets/images/Images/Strategic Planning-Images/strategic-planning-banner.png";
import { MainPageHeader } from "main/components";

type Props = {};

const CookiePolicy = (props: Props) => {
  const [data, setData] = useState<any>(undefined);
  useEffect(() => {
    window.scrollTo(0, 0);
    setData(content);
  }, []);

  return (
    <>
      <div className="Privacy_Policy">
        <MainPageHeader
          mobilebgImage={cookieBanner}
          backgroundImage={cookieBanner}
          heading={"Cookie Policy"}
          description={
            "This Cookie Policy explains what cookies are, types of cookies, how the cookies are categorized and an identifiable individual’s (“your”) rights to control Yantr.ai’s (“our”, “Yantr.ai”) use of them. This policy was updated on 22 May 2025."
          }
          descriptionClass="text-white-color font-family-roboto w-100"
        />
        <div className="container d-flex col-12 section2 gap-20 py-60">
          <div className="row">
            <div className="col-12 col-lg-12">
              <p className="text-primary1 font-30 fonts-800 pb-20 line-35 font-family-roboto footer-content">
                What are Cookies
              </p>
              <p className="fonts-400 font-18 font-family-roboto text-black-90 pb-40 line-24 footer-subcontent">
                A cookie is a piece of information that webserver sends to an
                identifiable individual’s (“your”) computer (browser file) when
                a website is accessed. It contains information about your visit
                to Tech Mahindra’s (“our”, “Yantr.ai”) web page, as well as any
                other information you have volunteered for. It helps to provide
                additional functionality to the site and analyze site usage more
                accurately. Cookies can gather information about your website
                usage or enable the website to recognize you as an existing
                customer when you return to our website at a later date.
              </p>
              <p className="text-primary1 font-30 fonts-800 pb-20 line-35 font-family-roboto footer-content">
                Types of Cookies
              </p>
              <p className="fonts-400 font-18 font-family-roboto text-black-90 pb-20 line-24 footer-subcontent">
                Here's a list of the main types of cookies we use, and what we
                use them for.
              </p>
              <div className="col-md-12">
                <p className="text-black-90 font-family-roboto font-20 fonts-800 pb-10 line-26 aboutus-subcontent">
                  {" "}
                  Session cookie:
                </p>
                <p className="text-black-90 font-family-roboto font-18 fonts-400 pb-20 line-26 footer-subcontent2">
                  Session cookies remains as long as a browsing session is
                  active and are intended to avoid user inconvenience during
                  browsing. These cookies allow websites to link the actions of
                  a user during a browser session and expire at the end of the
                  browsing session. Session cookies also assist the user in
                  navigating the website, and allow the user to access secure
                  parts of the webpage when logged in.
                </p>
              </div>
              <div className="col-md-12">
                <p className="text-black-90 font-family-roboto font-20 fonts-800 pb-10 line-26 aboutus-subcontent">
                  {" "}
                  Persistent Cookie:
                </p>
                <p className="text-black-90 font-family-roboto font-18 fonts-400 pb-40 line-26 footer-subcontent2">
                  Persistent cookies are stored on a user’s device even after
                  termination of a browsing session. It helps in recalling the
                  preferences or actions of the user. Persistent cookies are
                  used for a variety of purposes such as retaining the visitor’s
                  language and regional preference(s) at the end of each
                  browsing session. It is also used to carry out a behavioural
                  analysis in order to enhance user experience and convenience,
                  also to provide targeted and relevant content to visitors.
                </p>
              </div>
              <p className="text-primary1 font-30 fonts-800 pb-20 line-35 font-family-roboto footer-content">
                Cookie Category
              </p>
              <p className="dark-header font-24 fonts-400 pb-20 line-32 font-family-roboto contactus-heading">
                Cookies are categorized into below based on their purpose and
                functionality under Cookie Settings in cookie banner:
              </p>
              <div className="col-md-12">
                <p className="text-black-90 font-family-roboto font-20 fonts-800 pb-10 line-26 aboutus-subcontent">
                  {" "}
                  Strictly Necessary Cookies:
                </p>
                <p className="text-black-90 font-family-roboto font-18 fonts-400 pb-20 line-26 footer-subcontent2">
                  These cookies are necessary for the website to function and
                  cannot be switched off in our systems. They are usually only
                  set in response to actions made by you which amount to a
                  request for services, such as setting your privacy
                  preferences, logging in or filling in forms. You can set your
                  browser to block or alert you about these cookies, but then
                  some parts of the site will not work. These cookies do not
                  store any personally identifiable information.
                </p>
                <table className="table table-bordered">
                  <thead>
                    <tr className="text-black-90 font-family-roboto font-18 fonts-400 pb-20 line-26 footer-subcontent2">
                      <th scope="col">Cookie Name</th>
                      <th scope="col"> Lifespan</th>
                      <th scope="col"> Hostname</th>
                      <th scope="col"> Default Category</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr className="text-black-90 font-family-roboto font-18 fonts-400 pb-40 line-26 footer-subcontent2">
                      <td>Path</td>
                      <td>Session</td>
                      <td>yantr.ai</td>
                      <td> Strictly Necessary Cookies</td>
                    </tr>
                  </tbody>
                </table>
              </div>
              <div className="col-md-12 mt-30">
                <p className="text-black-90 font-family-roboto font-20 fonts-800 pb-10 line-26 aboutus-subcontent">
                  {" "}
                  Your Choices and Rights
                </p>
                <p className="text-black-90 font-family-roboto font-18 fonts-400 pb-40 line-26 footer-subcontent2">
                  There are ways you can control and manage cookies on your
                  device. Please remember that any setting changed by you will
                  apply to all websites you visit unless you choose to block
                  cookies from any particular site.
                </p>
              </div>
              <p className="dark-header font-28 fonts-400 pb-20 line-32 font-family-roboto contactus-heading">
                Updates to this Cookie Policy
              </p>
              <p className="fonts-400 font-18 font-family-roboto text-black-90 pb-20 line-26 footer-subcontent">
                This Cookie Policy may be updated periodically. We will
                encourage you to check for changes to this Cookie Policy
                occasionally, which will be available at:&nbsp;
                <a href="/cookies-policy">Cookie Policy</a>
              </p>
              <p className="fonts-400 font-18 font-family-roboto text-black-90 pb-20 line-26 footer-subcontent">
                To get further information on Tech Mahindra’s personal data
                collection and processing please check at:&nbsp;
                <a href="/privacy-policy">Privacy Policy</a>
              </p>
              <p className="fonts-400 font-18 font-family-roboto text-black-90 pb-40 line-26 footer-subcontent">
                On some occasions, we may also actively advise you of specific
                data handling activities or significant changes to this Cookie
                Policy, as required by the applicable law.
              </p>
              <p className="dark-header font-28 fonts-400 pb-20 line-32 font-family-roboto contactus-heading">
                Contact Us
              </p>
              <p className="fonts-400 font-family-roboto font-18 text-black-90 pb-20 line-26 footer-subcontent">
                If you have any questions about this Cookies Policy or wish to
                contact us for any reason in relation to our personal data
                processing, please contact us at:&nbsp;
                <a href="mailto:yantrai.coreteam@techmahindra.com">
                  yantrai.coreteam@techmahindra.com
                </a>
              </p>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default CookiePolicy;
